import React, { FunctionComponent } from 'react';
import { List, ListItemButton } from '@mui/material';
import { ITSTourSteps, stepDisplayNames, tourTocHasStep } from './tour-steps';
import { useTour } from '@reactour/tour';

export const TourTOC: FunctionComponent = () => {
  const { steps, setCurrentStep } = useTour();
  const tourSteps = steps as ITSTourSteps;

  const onClick = (stepIndex: number) => {
    setCurrentStep(stepIndex);
  };

  return (
    <List sx={{ listStyleType: 'disc', marginLeft: '1.5em' }}>
      {tourSteps.map((v, i) =>
        tourTocHasStep(v.stepName) ? (
          <ListItemButton
            key={i}
            sx={{ display: 'list-item', p: '0.5em 0' }}
            onClick={() => onClick(i)}
          >
            {stepDisplayNames[v.stepName]}
          </ListItemButton>
        ) : null
      )}
    </List>
  );
};
